<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{

    }
  },
  provide(){
    return {
      // reload:this.reload
    }
  },
  mounted() {
    console.log('App mounted');
  },
  beforeDestroy() {
    alert('App beforeDestroy');
    window.removeEventListener('beforeunload', this.handleStorageChange)
    // window.removeEventListener('unload', this.handleUnload)
    // document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    handleStorageChange(event) {
      console.log('Storage changed:', event);
    }
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  overflow: hidden; */
}
@media screen and (min-width:1100px){
    #app{
      min-width: 1200px
    }
}



</style>
